module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_1_3-b4627516d35ac63808695f2bc75ff56e.png";